module.exports = "/lucky-balls/img/color_betting/yellow.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/color_betting/yellow.png
// module id = 983
// module chunks = 0